var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60838 0.960619L5.44112 0.330224C5.32494 -0.108366 4.70315 -0.110924 4.58441 0.327667L4.4146 0.956782C3.96007 2.63698 2.64244 3.94636 0.959655 4.39134L0.330206 4.55757C-0.109003 4.67393 -0.110279 5.29538 0.327653 5.4143L0.957102 5.58436C2.63733 6.03957 3.9473 7.35663 4.39162 9.03938L4.55888 9.66978C4.67506 10.1084 5.29685 10.1109 5.41559 9.67233L5.5854 9.04322C6.03993 7.36302 7.35756 6.05364 9.04034 5.60866L9.66979 5.44243C10.109 5.32607 10.1103 4.70462 9.67235 4.5857L9.0429 4.41564C7.36267 3.96042 6.0527 2.64337 5.60838 0.960619Z",
    fill: "#9B29FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleStar);
export default __webpack_public_path__ + "static/media/purple-star.8752f31a625f9b5ed78fa466108d22b1.svg";
export { ForwardRef as ReactComponent };